import Vue from 'vue';

Vue.filter('stringToDate', (value: string) => {
  if (!value) {
    return '<n/a>';
  }
  const intValue = parseInt(value, 10);
  const date = new Date(intValue * 1000);

  return `${date.getDate()}.${date.getUTCMonth() + 1}.${date.getUTCFullYear()}`;
});
